import { Box } from '@mui/material'
import { t } from 'i18next'
import ButtonPrimaryOutlined from 'src/components/shared/ui/ButtonPrimaryOutlined'
import ButtonSecondary from 'src/components/shared/ui/ButtonSecondary'
import InputSearch from 'src/components/shared/ui/InputSearch'
import LexnetDialog from 'src/components/shared/ui/LexnetDialog'
import FieldsetGroup from 'src/components/shared/ui/form/fields/FieldsetGroup/FieldsetGroup'
import ExpedientAutocomplete from 'src/components/shared/ui/lexon/ExpedientAutocomplete'
import { Expedient } from 'src/interfaces/lexon'

import { dialogSelectorDocumentStyles as styles } from './DialogSelectorDocumentStyles'

type Props = {
  title: string
  isOpened: boolean
  close: () => void
  next: () => void
  inputSearch: string
  setInputSearch: (search: string) => void
  selectedExpedient: Expedient | null
  setSelectedExpedient: (expedient: Expedient | null) => void
}

export default function DialogSelectorDocument(props: Props): JSX.Element {
  const {
    title,
    isOpened,
    next,
    close,
    inputSearch = '',
    setInputSearch,
    selectedExpedient = null,
    setSelectedExpedient
  } = props

  return (
    <>
      <LexnetDialog
        title={title}
        isOpen={isOpened}
        close={close}
        maxWidth="lg"
        buttons={
          <>
            <ButtonPrimaryOutlined onClick={close}>{t('actions.cancel')}</ButtonPrimaryOutlined>
            <ButtonSecondary onClick={next} disabled={!inputSearch && selectedExpedient === null}>
              {t('actions.next')}
            </ButtonSecondary>
          </>
        }
      >
        <Box sx={styles.description}>{t('form.field.search_files')}</Box>

        <FieldsetGroup legend={t('form.legend.search_files')}>
          <Box sx={styles.wrapperInputSearch}>
            <InputSearch
              id="search-document"
              value={inputSearch}
              onChange={setInputSearch}
              placeholder={t('form.placeholders.search_file')}
              clearable
            />
          </Box>
        </FieldsetGroup>

        <FieldsetGroup legend={t('form.legend.files_from_lexon')}>
          <ExpedientAutocomplete
            selectedExpedient={selectedExpedient}
            setSelectedExpedient={setSelectedExpedient}
          />
        </FieldsetGroup>
      </LexnetDialog>
    </>
  )
}
